import { ConfigFactory } from './config.factory';

export default angular
  .module('ng1-config', [])
  .service('configFactory', ConfigFactory)
  .name;
